__turbopack_context__.v({
  "bodyContainer": "TableRenameModal-module__Pcnuka__bodyContainer",
  "bodyContent": "TableRenameModal-module__Pcnuka__bodyContent",
});
